import { ErrorResponse } from "./socket.responses";

export class ResponseError extends Error {
  typename = "";
  message = "";
  errorData = [""];
  constructor(errorResp: ErrorResponse) {
    super(errorResp.typename);
    this.typename = errorResp.typename;
    this.message = errorResp.message;
    this.errorData = errorResp.errorData;
  }
}

export enum GameResponseErrors {
  GAME_NOT_FOUND = "GAME_NOT_FOUND",
  USER_ALREADY_CONNECTED = "USER_ALREADY_CONNECTED",
  MAX_USERS_LIMIT_REACHED = "MAX_USERS_LIMIT_REACHED",
}

export enum VotingResponseErrors {
  USER_CANT_VOTE = "USER_CANT_VOTE",
  VOTE_NOT_FOUND = "VOTE_NOT_FOUND",
}
export enum TimerResponseErrors {
  TIMER_ALREADY_EXISTS = "TIMER_ALREADY_EXISTS",
  TIMER_DOES_NOT_EXIST = "TIMER_DOES_NOT_EXIST",
}
export enum ServerResponseErrors {
  VALIDATION_ERROR = "VALIDATION_ERROR",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  AUTH_ERROR = "AUTH_ERROR",
  FORBIDDEN_ERROR = "FORBIDDEN_ERROR",
}
